export default {
  title: 'Konfigurator zamówienia',
  newOrder: 'Poznaj naszą ofertę',
  newOrderTooltip: 'Kliknij aby poznać koszt przepakowania aktualnego portfolio',
  customOrder: 'Opisz przepakowanie, jakie chcesz wykonać',
  customOrderTooltip: 'Kliknij aby stworzyć formularz wyceny niestandardowego przepakowania',
  choose: 'Wybierz opcję',
};
